import React from 'react';
import { FeedViewContext } from './FeedViewContext';
import { FeedViewForm } from './FeedViewForm';

// The thin wrapper this repo's conventions ask for: read Context here, hand plain props to a pure
// component. FeedViewForm stays testable with nothing but props — which is what its twenty-two
// existing cases rely on — while the page stops threading ten of them through.
//
// `onSubmit` and `isRunning` stay props rather than coming from Context, deliberately. Submitting is
// the page's decision: it owns the read, the column negotiation that shapes the request, and the
// drill-down path the read replaces. The query is Context's; issuing it is not.
export const FeedViewFormPanel = ({ onSubmit, isRunning }) => {
  const {
    formState,
    isFormCollapsed,
    feeds,
    isLoadingFeeds,
    feedsError,
    reloadFeeds,
    patchForm,
    expandForm,
    companyResolution,
  } = React.useContext(FeedViewContext);

  return (
    <FeedViewForm
      formState={formState}
      patchForm={patchForm}
      onSubmit={onSubmit}
      isRunning={isRunning}
      feeds={feeds}
      isLoadingFeeds={isLoadingFeeds}
      feedsError={feedsError}
      onRetryFeeds={reloadFeeds}
      isCollapsed={isFormCollapsed}
      onExpand={expandForm}
      companyText={companyResolution.text}
      onCompanyTextChange={companyResolution.setText}
      isResolvingCompanies={companyResolution.isResolving}
      resolveProgress={companyResolution.progress}
      resolveResult={companyResolution.result}
      onResolveCompanies={companyResolution.flush}
      onDismissUnresolved={companyResolution.dismiss}
    />
  );
};
